<template lang="pug">
  div.frame(:style="sty()",:class="{ alert: alert }")
</template>

<script>
export default {
  name: 'Space',
  data () {
    return {
      width: 844,
      height: 528,
      left: 0
    };
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    },
    view () {
      this.update();
    }
  },
  methods: {
    update () {
      this.set = this.sets[this.number];
      if (this.set !== undefined) {
        this.width = this.c2p(this.set.space[0]);
        this.height = this.c2p(this.set.space[2]);
        this.left = this.c2p(this.set.left);
        if (this.set.alert) {
          this.alert = true;
        } else {
          this.alert = false;
        }
      }
    },
    sty () {
      return {
        backgroundPosition: 'left ' + this.left + 'px top',
        width: this.width + 'px',
        height: this.height + 'px'
      };
    }
  },
  created () {
    this.update();
  }
};
</script>
<style lang="stylus" scoped>
  .frame
    position absolute
    left 0
    top 0
    background #ffffff url("../../assets/bg_grid_top.svg") 0 top
    &:before
      content ""
      position absolute
      display block
      left 0
      top 0
      border 2px dashed #bbbbbb
      right 0
      bottom 0
    &.alert:before
      border-color #cc0000
</style>



// WEBPACK FOOTER //
// src/components/top/Space.vue